import { render, staticRenderFns } from "./CuposDisponibles.vue?vue&type=template&id=6352f3cc&"
import script from "./CuposDisponibles.vue?vue&type=script&lang=js&"
export * from "./CuposDisponibles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports